import { STEP_LABELS, TOTAL_STEPS } from "@/app/calculator/constants/calculatorData";
import { ProgressBar, TrustBar } from "./Ui";
import { StepLocation } from "./StepLocation";
import { StepSummary } from "./StepSummary";
import { StepActivity } from "./StepActivity";
import { StepDetails } from "./StepDetails";
import { StepOffice } from "./StepOffice";
import { ArrowLeft, ArrowRight } from "lucide-react";

export function WizardCard({
  step,
  data,
  update,
  next,
  back,
  isValid,
  isLast,
  isFirst,
}) {
  return (
    <div
      className="bg-[#fafafa] rounded-3xl shadow-xl border border-gray-100
                 p-4 sm:p-8 lg:p-10 xl:p-14 2xl:p-16 mb-8 lg:mb-0 w-full"
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-[11px] sm:text-xs font-semibold text-gray-400">
          {step} / {TOTAL_STEPS}
        </span>

        <span className="text-[11px] sm:text-xs font-semibold text-[#B8893A] uppercase tracking-widest text-right">
          {STEP_LABELS[step - 1]}
        </span>
      </div>

      {/* Progress */}
      <ProgressBar step={step} total={TOTAL_STEPS} />

      {/* Step Content */}
      <div className="min-h-[320px] sm:min-h-[380px]">
        {step === 1 && (
          <StepActivity
            value={data.activity}
            onChange={(v) => update("activity", v)}
          />
        )}

        {step === 2 && <StepDetails data={data} onChange={update} />}

        {step === 3 && (
          <StepOffice
            value={data.office}
            onChange={(v) => update("office", v)}
          />
        )}

        {step === 4 && <StepLocation data={data} onChange={update} />}

        {step === 5 && <StepSummary data={data} />}
      </div>

      {/* Navigation */}
      {!isLast && (
        <div
          className="flex flex-col sm:flex-row items-stretch sm:items-center
                     gap-3 mt-6 pt-5 border-t border-gray-100"
        >
          {/* Back */}
          {!isFirst && (
            <button
              onClick={back}
              className="flex items-center justify-center gap-2
                         w-full sm:w-auto px-5 py-3.5 sm:py-3 rounded-xl border border-gray-200
                         text-sm font-semibold text-gray-500
                         hover:bg-gray-50 hover:text-gray-800
                         transition active:scale-[0.98]"
            >
              <ArrowLeft size={16} />
              Back
            </button>
          )}

          {/* Next */}
          <button
            onClick={next}
            disabled={!isValid}
            className={`flex items-center justify-center gap-2
              w-full sm:flex-1 py-4 rounded-xl text-sm font-bold
              transition shadow-lg active:scale-[0.98]
              ${
                isValid
                  ? "bg-[#B8893A] text-white hover:bg-[#a07830] shadow-[#B8893A]/20"
                  : "bg-gray-100 text-gray-400 cursor-not-allowed shadow-none"
              }`}
          >
            Continue Step
            <ArrowRight size={18} />
          </button>
        </div>
      )}

      {/* Summary edit */}
      {isLast && (
        <div className="mt-5 pt-5 border-t border-gray-100">
          <button
            onClick={back}
            className="flex items-center gap-2 text-sm font-semibold
                       text-[#B8893A] hover:text-[#a07830] transition"
          >
            <ArrowLeft size={16} />
            Edit my answers
          </button>
        </div>
      )}

      {/* Trust bar */}
      {!isLast && <TrustBar />}
    </div>
  );
}
